import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function Transition() {
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => navigate("/restitution"), 2400);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="relative min-h-screen overflow-hidden bg-sand-50 flex items-center justify-center" data-testid="transition-page">
      {/* Concentric breathing rings */}
      <div className="absolute inset-0 flex items-center justify-center -z-10">
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: [0.6, 1.6, 0.6], opacity: [0, 0.35, 0] }}
            transition={{
              duration: 3.4,
              delay: i * 0.6,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="absolute h-[360px] w-[360px] rounded-full border border-sand-400/50"
          />
        ))}
        {/* central glow */}
        <motion.div
          initial={{ opacity: 0.5 }}
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
          className="absolute h-32 w-32 rounded-full bg-gradient-to-br from-sand-300 to-sand-400 blur-2xl"
        />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative text-center px-6"
      >
        <p className="text-[11px] uppercase tracking-[0.4em] text-sand-500 flex items-center justify-center gap-3">
          <span className="h-px w-8 bg-sand-400" />
          Quelques instants
          <span className="text-sand-400">✦</span>
          <span className="h-px w-8 bg-sand-400" />
        </p>
        <h1
          className="mt-8 font-display text-4xl md:text-6xl text-ink leading-tight"
          data-testid="transition-title"
        >
          Analyse de votre
          <span className="text-sand-500"> diagnostic</span>
          <span className="inline-flex ml-2">
            {[0, 1, 2].map((i) => (
              <motion.span
                key={i}
                className="inline-block"
                animate={{ opacity: [0.2, 1, 0.2] }}
                transition={{ duration: 1.4, repeat: Infinity, delay: i * 0.2 }}
              >
                .
              </motion.span>
            ))}
          </span>
        </h1>
        <p className="mt-6 max-w-md mx-auto text-ink-soft leading-relaxed italic text-base">
          Nous laissons résonner ce que vous venez d'écrire.
        </p>
      </motion.div>
    </div>
  );
}
